<template functional>
  <div
    class="stars"
    :style="`
        --highlightedPercentage: ${$options.methods.highlightedPercentage(
          props.rating
        )}%;
        --maxStars: '${$options.methods.maxStars()}';
      `"
  />
</template>

<script>
const MAX_RATING = 5

export default {
  name: 'StarRating',
  props: {
    /**
     * Number of stars to be highlighted
     *
     * @type {number}
     */
    rating: {
      type: Number,
      default: 0
    }
  },
  methods: {
    highlightedPercentage(rating) {
      return (rating / MAX_RATING) * 100
    },

    maxStars() {
      return '★'.repeat(MAX_RATING)
    }
  }
}
</script>

<style lang="scss" scoped>
.stars {
  --letterSpacing: 3px;
  --gradientPercentage: calc(
    var(--highlightedPercentage) - var(--letterSpacing) / 2
  );

  font-size: 12px;

  &::before {
    content: var(--maxStars);
    letter-spacing: var(--letterSpacing);
    background: linear-gradient(
      90deg,
      $red var(--gradientPercentage),
      $grey var(--gradientPercentage)
    );
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
